import store from '@/store'

const validatePermissions = [ "ares-validate-lidar-evaluation" ]

const routes = [
    {
        path: 'validate/:evaluationId',
        name: 'ARESValidateEvaluation',
        component: () => import('@/pages/ares/ValidateEvaluation.vue'),
        props: true,
        meta: {
            auth: true,
            private: true,
            gate: () => validatePermissions.some(p => store.state.auth.permissions.includes(p))
        }
    }
]

export default routes